import { WilsonApp } from '../wilson-app';

export interface WorkTime {
  month: string;
  year: string;
  hour: number;
}

export interface WorkTimeDetails {
  month: string;
  year: string;
  actualHour: number;
  targetHour: number;
  overNightHour: number;
  weekEndHour: number;
  holidaysHour: number;
}

export interface ShiftWorkTimeReport {
  name: string;
  shiftId: string;
  startDate: string;
  shiftName: string;
  organizationalUnitName: string;
  userOrganizationalUnitName: string;
  shiftCategory: string;
  shiftComment: string;
  processingStatus: string;
  plannedStartDateTime: string;
  plannedEndDateTime: string;
  plannedDuration: string;
  reportedStartDateTime: string;
  reportedEndDateTime: string;
  reportedDuration: string;
  customer: string;
  agreement: string;
  activityName: string;
  activityCategory: string;
  activityComments: string;
  serviceNumber: string;
  reportedStartLocation: string;
  reportedStartLocationCode: string;
  reportedStartLocationDescription: string;
  reportedStartLocationName: string;
  reportedEndLocation: string;
  reportedEndLocationCode: string;
  reportedEndLocationDescription: string;
  reportedEndLocationName: string;
  plannedStartLocation: string;
  plannedStartLocationCode: string;
  plannedStartLocationDescription: string;
  plannedStartLocationName: string;
  plannedEndLocation: string;
  plannedEndLocationCode: string;
  plannedEndLocationDescription: string;
  plannedEndLocationName: string;
  shiftReportComment: string;
  personnelId: string;
  cargo: string | null;
  orderNumber: string | null;
  wagonNumber: string | null;
  locomotiveNumber: string | null;
  createdFrom: WilsonApp;
}

export enum DurationDisplayMode {
  Decimal,
  Time,
}
